<video #playerEl controls="controls" class="preview-object" [class.hidden]="invalidMedia"></video>

<default-preview *ngIf="invalidMedia"></default-preview>